

















































































































































































import Vue from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  ASSESSMENT_ERROR,
  TENANT_INFO,
  TENANT_INFO_DETAILS,
  TENANT_INFO_LOADING
} from "@/store/modules/candidates/constants";
import { GET_USER_DETAILS } from "@/store/modules/auth/constants";
import {
  GET_ASSESSMENT_PDF,
  GET_ASSESSMENT_SUMMARY,
  GET_ROLE_BY_NAME
} from "@/store/modules/common/constants";
import { AssessmentSummary } from "@/interfaces/assessments";
import GoBackHeader from "@/components/shared/GoBackHeader.vue";
import { download_file, generate_random_key } from "@/utils/global";
import IndividualSummary from "@/components/assessments/IndividualSummary.vue";
import { get_random_color } from "@/utils/colors";
import AssessmentError from "@/components/assessments/AssessmentError.vue";
import { AssessmentErrorTypes } from "@/store/modules/candidates/interfaces";
import { ROOT_ERROR, ROOT_NOTIFICATION } from "@/store/modules/root/constants";

export default Vue.extend({
  name: "AssessmentReport",
  components: {
    AssessmentError,
    IndividualSummary,
    GoBackHeader
  },
  beforeRouteEnter(to, from, next) {
    const param_id = to.params.assessment_id;
    if (!param_id) next(false);
    else next();
  },
  beforeRouteUpdate(to, from, next) {
    const param_id = to.params.assessment_id;
    if (!param_id) next(false);
    else next();
  },
  data() {
    return {
      data_loading: true, // loading for fetching assessment summary from DB
      pdf_loading: false, // loading for fetching assessment pdf file from DB
      assessment_summary: null as AssessmentSummary.ShortscaleResult | null,
      individualist_summary: [
        "Individualists walk to the beat of their own drum and find unique ways of expressing themselves and their originality.",
        "Typical Individualists make an art out of brushing aside tradition and conventions to do things their own way. They are always on the hunt for novel ways of doing things, defying the rules with a flare for the creative and sometimes for the dramatic. They are driven to express their individuality and don't let anyone else define who they are or dictate what they do.",
        "Individualists tend to feel deeply and tap into an emotional layer that can drive their decisions and actions. At the same time, it can also mean they can be temperamental and experience self-doubt. They can be particularly sensitive to criticism.",
        "Individualists tend to seek and appreciate things that are new, beautiful, and different. They have a talent for seeing things in a unique and thought-provoking way, and can chafe at being micromanaged or controlled.",
        "At their best, they are highly creative, inspired, and bring a new and different perspective to any situation. However, they can tend to be reactive, withdrawn, and anxious in difficult situations, and sometimes can act out and be rebellious just for the sake of it, which can get in the way of their success and relationships with people who don't see things the same way as they do."
      ] as string[],
      individualist_talents: [] as string[],
      individualist_growth: [] as string[]
    };
  },
  computed: {
    AssessmentErrorTypes() {
      return AssessmentErrorTypes;
    },
    AssessmentSummary() {
      return AssessmentSummary;
    },
    ...mapGetters("candidate", {
      tenant_info: TENANT_INFO,
      tenant_info_details: TENANT_INFO_DETAILS
    }),
    ...mapGetters("common", {
      get_role_by_name: GET_ROLE_BY_NAME
    }),
    ...mapGetters("auth", {
      get_user_details: GET_USER_DETAILS
    })
  },
  watch: {
    async tenant_info_details(n) {
      if (n) {
        await this.init();
      }
    }
  },
  async mounted() {
    await this.init();
  },
  methods: {
    generate_random_key,
    ...mapActions("common", {
      fetch_assessment_summary: GET_ASSESSMENT_SUMMARY,
      fetch_assessment_pdf: GET_ASSESSMENT_PDF
    }),
    ...mapMutations("candidate", {
      set_assessment_error: ASSESSMENT_ERROR,
      set_assessment_loading: TENANT_INFO_LOADING
    }),
    ...mapMutations({
      root_notification: ROOT_NOTIFICATION,
      root_error: ROOT_ERROR
    }),
    async init() {
      this.data_loading = true;
      const recruiter_role = this.get_role_by_name("recruiter");
      const recruiter_admin_role = this.get_role_by_name("recruiter admin");
      if (
        this.get_user_details.role_id === recruiter_role.id ||
        this.get_user_details.role_id === recruiter_admin_role.id
      ) {
        const summary = await this.fetch_assessment_summary(
          this.$route.params.assessment_id
        );
        if (summary) {
          summary.shortscaleResult.dimensions.map(
            (val: AssessmentSummary.Dimension) =>
              (val.color = get_random_color())
          );
          this.assessment_summary = summary;
          this.data_loading = false;
          this.set_assessment_loading(false);
        } else this.set_assessment_error(true);
      } else await this.init_candidate_process();

      // this.process_individualist_summary();
      this.data_loading = false;
    },
    async init_candidate_process() {
      if (this.tenant_info.loading) return;
      this.data_loading = true;
      // Check if assessment summary exists
      if (
        this.tenant_info.details &&
        this.tenant_info.details.assessment_summary
      ) {
        this.tenant_info.details.assessment_summary.shortscaleResult.dimensions.map(
          (val: AssessmentSummary.Dimension) => (val.color = get_random_color())
        );

        this.assessment_summary = this.tenant_info.details.assessment_summary;
      }
      // If assessment summary not exists => fetch assessment summary
      else if (this.tenant_info.details) {
        const summary = await this.fetch_assessment_summary(
          this.tenant_info.details.id
        );
        summary.shortscaleResult.dimensions.map(
          (val: AssessmentSummary.Dimension) => (val.color = get_random_color())
        );
        this.assessment_summary = summary;
      } else {
        this.set_assessment_error(true);
      }
      this.data_loading = false;
      this.set_assessment_loading(false);
    },
    async get_assessment_report() {
      this.pdf_loading = true;
      const recruiter_role = this.get_role_by_name("recruiter");
      const recruiter_admin_role = this.get_role_by_name("recruiter admin");
      let assessment_id: number | null = null;
      if (
        this.get_user_details.role_id === recruiter_role.id ||
        this.get_user_details.role_id === recruiter_admin_role.id
      ) {
        assessment_id = parseInt(this.$route.params.assessment_id);
      } else assessment_id = this.tenant_info.details.id;
      if (!assessment_id) {
        this.root_error(this.$t("errors.assessment-report-failed"));
        this.pdf_loading = false;
        return;
      }
      const url = await this.fetch_assessment_pdf(assessment_id);
      if (!url) this.root_error(this.$t("errors.assessment-report-failed"));
      else if (url.includes("http") || url.includes("https"))
        await download_file(url);
      else this.root_notification(this.$t("success-messages.pdf-creation"));
      this.pdf_loading = false;
    }
  }
});
